/* eslint-disable check-file/filename-naming-convention */
/**
 * Error codes that standard actions / connectors might return.
 * based on Http error codes
 */
export enum ErrorCodes {
  INTERNAL_ERROR = 500,
  CANCELLED_REQUEST = 499,
  INVALID_INPUT = 400,
  NOT_FOUND = 404,
  SESSION_EXPIRED = 440,
  BAD_GATEWAY = 502,
  TIMEOUT = 504,
  SERVICE_UNAVAILABLE = 503,
  UNPROCESSABLE_ENTITY = 422,
  UNAUTHORIZED = 401,
  RATE_LIMIT = 429,
  PRECONDITIONS = 412,
  FORBIDDEN = 403,
}
